import * as React from 'react';
import { getDefaultBorderIncludes } from './Utils';
import { TableRow, TableRowProps } from './TableRow';
import { ReactNode } from 'react';

type TableHeaderProps = TableRowProps & {children: ReactNode };

/**
 * This component displays the titles for the rows.
 */
export class TableHeader extends React.PureComponent<TableHeaderProps> {
  render() {
    const {
      includeLeftBorder,
      includeBottomBorder,
      includeRightBorder,
      includeTopBorder
    } = getDefaultBorderIncludes(this.props);


    const rowCells: any[] = React.Children.toArray(this.props.children);
    const {children, ...rest} = this.props

    return (
      <TableRow
        key={'header'}
        includeLeftBorder={includeLeftBorder}
        includeBottomBorder={includeBottomBorder}
        includeRightBorder={includeRightBorder}
        includeTopBorder={includeTopBorder}
      >
        {rowCells.map((rc, columnIndex) =>
          React.cloneElement(rc, {
            key: columnIndex,
            isHeader: true,
            fontSize: this.props.fontSize,
            textAlign: this.props.textAlign,
            includeLeftBorder: columnIndex === 0,
            includeRightBorder: columnIndex !== rowCells.length - 1
          })
        )}
      </TableRow>
    );
  }
}
